import { RootState } from 'types/state'
import { authSelectors } from './auth'
import { orgSelectors } from './orgs'

// selectors
export const adsSelectors = {
  getEnableAdsForOrg: (state: RootState) => {
    if (orgSelectors.getCobrandingOrg(state)) {
      return false
    } else {
      return true
    }
  },
  getAdIntensity: (state: RootState): number => authSelectors.getAdIntensity(state),
}
